import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStep4 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Target.1",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_14056",
		"data-name": "Group 14056",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11830",
				"data-name": "Path 11830",
				d: "M20.053,12.474a8.527,8.527,0,1,1-8.527-8.526",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11831",
				"data-name": "Path 11831",
				d: "M16.263,12.474a4.737,4.737,0,1,1-4.737-4.737",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11832",
				"data-name": "Path 11832",
				d: "M18.158,3,15.316,5.842V8.684h2.842L21,5.842l-1.9-.947Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11833",
				"data-name": "Path 11833",
				d: "M15.32,8.68l-3.79,3.79",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_11834",
		"data-name": "Path 11834",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgStep4;
